import styled, { css } from 'styled-components';

import {
  breakpoints,
  colors,
  typography,
} from '../../theme';

import {
  Text,
} from '../../elements';

export const Wrapper = styled.div`
  border: 0.01em solid ${colors.GREY__DARK};
  display: block;
  flex-grow: 0;
  flex-shrink: 0;
  height: ${382 / typography.BASE_FONT_SIZE}rem;
  opacity: 1;
  position: relative;
  width: ${382 / typography.BASE_FONT_SIZE}rem;

  &.active {
    transition: background .2s ease-in-out,
                border .2s ease-in-out,
                opacity .2s ease-in-out,
                visibility 0s ease-in-out .3s;
    visibility: visible;
  }

  &.inactive {
    transition: visibility 0s ease-in-out;
    visibility: hidden;
  }

  ${(props) => props.faded && css`
    opacity: 0.3;
  `}

  ${(props) => !props.faded && css`
    &:hover {
      background: ${colors.GREY__WHITE};
      border: 0.01em solid transparent;
    }
  `}

  ${(props) => props.popUp && css`
    background: ${colors.GREY__WHITE};
    border: 0.01em solid transparent;
    left: 50%;
    position: fixed;
    top: 50%;
    z-index: 999;

    &.active {
      transform: none !important;
      transition: transform .3s ease-in-out,
                  visibility 0s ease-in-out;
      visibility: visible;
    }

    &.inactive {
      transition: transform .3s ease-in-out,
                  visibility 0s ease-in-out .3s;
      visibility: hidden;
    }
  `}

  @media ${breakpoints.COMPACT} {
    &.inactive {
      background: ${colors.GREY__WHITE};
      border: 0.01em solid transparent;
      visibility: visible;
    }
  }
`;

export const Content = styled.div`
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
`;

export const Top = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  ${typography.BODY}

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const HeaderText = styled.div`
  padding: ${12 / typography.BASE_FONT_SIZE}rem;
  padding-top: ${8 / typography.BASE_FONT_SIZE}rem;
  transition: transform .3s ease-in-out;
  transform-origin: left top;
`;

export const Number = styled.span`
  margin-top: -${1 / typography.BASE_FONT_SIZE}rem;
  ${typography.BODY__BOLD}
  position: absolute;
`;

export const Title = styled.span`
  text-indent: ${28 / typography.BASE_FONT_SIZE}rem;
  display: inline-block;
`;

export const ImageWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: 100%;

  @media ${breakpoints.COMPACT} {
    transition: opacity .2s ease-in-out,
                visibility .2s ease-in-out;

    .inactive & {
      opacity: 0;
      visibility hidden;
    }
  }
`;

export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

export const Bottom = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: ${12 / typography.BASE_FONT_SIZE}rem;
  padding-bottom: ${8 / typography.BASE_FONT_SIZE}rem;
  ${typography.BODY__SMALL}
`;

export const Info = Text.extend`
  max-height: ${typography.BODY__SMALL.lineHeight}em;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  ${(props) => props.wrapText && css`
    max-height: none;
    white-space: normal;
  `}
  
  @media ${breakpoints.COMPACT} {
    .inactive & {
      max-height: none;
      white-space: normal;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/ScrollingListItem/style.js